// extracted by mini-css-extract-plugin
module.exports = {"scrollTop":"ScrollTopArrow_scrollTop__3HdVB","fadeIn":"ScrollTopArrow_fadeIn__16sWS"};